<template>
  <div id="header" class="header-block">
    <div class="row mx-0 navbar-container col-lg-12 px-lg-4 mx-auto py-2">
      <div class="col-12 px-0">
        <b-navbar toggleable="lg" type="dark" variant="custom" class="main-menu py-0  px-0 h-100">
          <b-navbar-toggle id="nav-collapse-button" target="nav-collapse">
            <i v-if="collapsed" class="fa fa-close text-white"></i>
          </b-navbar-toggle>
          <b-collapse  id="nav-collapse" is-nav  class="pt-0 row mx-0 justify-content-between">
            <div class="col-2 col-lg-1 col-xl-2 d-none d-lg-block px-0">
              <b-navbar-brand class="header-logo-container justify-content-center">
                <router-link :to="{ name: 'home' }" class="header-logo-route mw-100">
                  <img class="header-logo" :src="logo" alt="VipMagnit казино лого">
                </router-link>
              </b-navbar-brand>
            </div>
            <div class="col-12 col-sm-11 col-lg-6 col-xl-6 px-0 px-lg-0 menu-list">
              <b-navbar-nav class="justify-content-start justify-content-md-start pt-3 pt-lg-0 px-4 px-lg-0 row mx-auto col-12 col-xl-10 ">
                <b-nav-item class="mx-0 d-block d-lg-none col">
                  <router-link :to="{ name: 'home' }" exact class="px-0 d-block text-center">
                    <img :src="logo" class="mobile-expanded-logo" alt="VipMagnit logo">
                  </router-link>
                </b-nav-item>

                <b-nav-item class="mx-0 mt-2 mt-sm-0 col px-0">
                  <router-link
                          :to="{ name: 'home' }"
                          active-class="active-page"
                          exact
                          class="px-0 d-block ">
                    <span class="menu-item d-inline-block d-lg-flex justify-content-center">Казино</span>
                  </router-link>
                </b-nav-item>
                <b-nav-item class="mx-0 mt-2 mt-sm-0 col px-0">
                  <router-link
                          :to="{ name: 'LaunchGame',
                           params: {
                             gameName:'WheelOfFortune',
                             gameId:1,
                             provider: 'WheelOfFortune'
                           }
                    }"
                          active-class="active-page"
                          exact
                          class="px-0 d-block pb-2 pb-lg-0">
                    <span class="menu-item d-inline-block d-lg-flex justify-content-center">Колесо</span>
                  </router-link>
                </b-nav-item>

                <b-nav-item class="mx-0 mt-2 mt-sm-0 col px-0">
                  <router-link
                          :to="{ name: 'deposit' }"
                          active-class="active-page"
                          exact
                          class="px-0 d-block pb-2 pb-lg-0">
                    <span class="menu-item d-inline-block d-lg-flex justify-content-center">Депозит</span>
                  </router-link>
                </b-nav-item>

                <b-nav-item class="mx-0 mt-2 mt-sm-0 col px-0">
                  <router-link
                          :to="{ name: 'withdraw' }" active-class="active-page"
                          exact
                          class="px-0 d-block pb-2 pb-lg-0"
                  >
                    <span class="menu-item d-inline-block d-lg-flex justify-content-center">Выплата</span>
                  </router-link>
                </b-nav-item>

                <b-nav-item class="mx-0 mt-2 mt-sm-0 col px-0">
                  <router-link
                          :to="{ name: 'bonuses' }" active-class="active-page"
                          exact
                          class="px-0 d-block pb-2 pb-lg-0"
                  >
                    <span class="menu-item d-inline-block d-lg-flex justify-content-center blink-text-yellow-red">Бонусы</span>
                  </router-link>
                </b-nav-item>

                <b-nav-item class="mx-0 mt-2 mt-sm-0 col px-0">
                  <router-link
                          :to="{ name: 'terms' }" active-class="active-page"
                          exact
                          class="px-0 d-block pb-2 pb-lg-0">
                    <span class="menu-item d-inline-block d-lg-flex justify-content-center">Условия</span>
                  </router-link>
                </b-nav-item>

                <b-nav-item class="mx-0 mt-2 mt-sm-0 col px-0">
                  <router-link
                          :to="{ name: 'UserLevels' }" active-class="active-page"
                          exact
                          class="px-0 d-block pb-2 pb-lg-0">
                    <span class="menu-item d-inline-block d-lg-flex justify-content-center">Уровень</span>
                  </router-link>
                </b-nav-item>

                <b-nav-item class="mx-0 mt-2 mt-sm-0 col px-0" v-if="socialLinks.tg_manager"
                            v-lazy-container="{ selector: 'img',loading: loader}"
                            target="_blank"
                            :href="socialLinks.tg_manager">
                      <img :src="loader"
                           alt="VIP Magnit telegram manager"
                           :data-src="tgIcon"
                           class="mw-100 m-auto footer-social-icon menu-item d-inline-block d-lg-flex py-1 blink-icon">
                </b-nav-item>
              </b-navbar-nav>
            </div>

            <div v-if="userDataFetched" class="col-12 col-lg-5 col-xl-4 d-none d-lg-block px-lg-0">
              <b-navbar-nav v-if="!userData">
                <li class="w-100">
                  <div class="auth-btns row mx-0 w-100 justify-content-lg-end">
                    <div class="text-right">
                      <router-link class="btn main-btn px-3" :to="{ name: 'login' }">
                        Вход
                      </router-link>
                    </div>
                    <div class="pl-3 pr-0">
                      <router-link class="btn dark-btn d-block" :to="{ path: '/registration' }">
                        Регистрация
                      </router-link>
                    </div>
                  </div>
                </li>
              </b-navbar-nav>
              <b-navbar-nav v-if="userData" class="row mx-0 justify-content-end">
                <div class="col-8 col-lg-10 col-xl-3 text-right pr-2">
                  <router-link  class="pt-0 header-username menu-item" :to="{ name: 'account', params: { placeName: 'profile' }}"
                                title="Перейти в профиль">
                    <span class="text-white mr-1">{{userData.login}}</span>
                  </router-link>
                  <router-link  class="pt-0 header-balances menu-item" :to="{ name: 'account', params: { placeName: 'balances' }}"
                  title="Показать балансы">
                  <span class="my-auto header-balance-info d-inline-block">
                      <span class="text-muted balance-word">Баланс: </span>
                      <span class="text-light-green">
                        <span class="blnc">{{ balance }}</span> {{ userData.currency_name }}
                      </span>
                    </span>
                  </router-link>
                </div>
                <div class="col-4 col-lg-2 col-xl-2 px-0 text-center row mx-0 align-self-center">
                  <a class="text-white cursor-pointer logout-link" @click.prevent="logout">
                    Выйти<i v-if="!loggingOut" class="fa fa-arrow-right ml-1"></i><i  v-else class="fa fa-spinner fa-spin"></i>
                  </a>
                </div>
              </b-navbar-nav>
            </div>
            <div v-else class="col-12 col-lg-2 d-none d-lg-block px-lg-0
                        row justify-content-center w-100 color-red mx-0 h-100 py-2 text-center">
              <i class="fa fa-spinner fa-spin fa-fw my-auto color-red"></i>
            </div>
          </b-collapse>

          <div class="row w-100 d-lg-none mx-0 mobile-header-menu col-12 px-0 h-100">
            <div class="col-8 col-md-6 px-0 text-center ml-auto mr-0">
              <b-navbar-brand class="mx-0 px-0">
                <router-link :to="{ name: 'home' }" class="mobile-logo-link">
                  <img class="px-3 header-logo" :src="logo" alt="VipMagnit logo">
                </router-link>
              </b-navbar-brand>
            </div>
            <div class="col-2 col-md-3 px-0 account-mobile text-right h-100 row mx-0">
              <div v-if="!userData" class="text-right pl-3 pr-0 px-sm-3 px-md-3 my-auto mx-sm-auto">
                <router-link :to="{ name: 'login' }" exact>
                  <img :src="userIconMobile" class="login-icon" alt="VipMagnit user icon">
                </router-link>
              </div>
              <div v-else class="text-right px-2 px-sm-3 px-md-3 my-auto mr-md-0 ml-md-auto">
                <b-dropdown class="mobile-account-drop">
                  <template v-slot:button-content class="account-drop-btn">
                    <img :src="userIconMobile" class="login-icon" alt="VipMagnit sign in icon">
                  </template>
                  <b-dropdown-item>
                   <router-link :to="{ name: 'account', params: { placeName: 'profile' }}">Баланс: {{balance}}</router-link>
                  </b-dropdown-item>
                  <b-dropdown-item :to="{ name: 'account', params: { placeName: 'profile' }}">
                      Профиль
                  </b-dropdown-item >
                  <b-dropdown-item href="#" @click.prevent="logout">
                     Выход |
                      <i v-if="!loggingOut" class="fa fa-arrow-right ml-1"></i>
                      <i v-else class="fa fa-spinner fa-spin"></i>
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
          </div>
        </b-navbar>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  components: {
  },
  data () {
    return {
      headerLogo: true,
      collapsed: true,
      logo: require('@/../public/images/logos/vp-logo.png'),
      userIcon: require('@/../public/images/icons/user.png'),
      userIconMobile: require('@/../public/images/icons/user.png'),
      loggingOut: false,
      tgIcon: require('@/../public/images/icons/social/tg.png'),
      loader: require('@/../public/images/icons/main-loader.svg'),
      headerTelegram: false
    }
  },
  computed: {
    userData () {
      return this.$store.getters.userData
    },
    socialLinks() {
      return this.$store.getters.getSocialLinks
    },
    balance () {
        try {
          let balance = this.$store.getters.userData.balance

          return  balance.toFixed(0)
        } catch (e) {
          console.log(e.message)
          return 0
        }
    },
    userDataFetched () {
      return this.$store.getters.userDataFetched
    }
  },
  methods: {
    logout () {
      this.loggingOut = true
      this.axios.get(
        this.$_config.baseUrl + '/Api/logout'
      ).then(() => {
        this.$store.dispatch('removeUserData')
        if (this.$route.name !== 'home') {
          return this.$router.push({name: 'home'})
        } else {
          window.location.reload(true)
        }
      }).catch(err => {
        console.log(err)
      })
    }
  },
  mounted () {
    this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
      if (collapseId === 'nav-collapse') {
        isJustShown ? this.collapsed = true : this.collapsed = false
      }
    });
  },
  watch: {
    collapsed(newVal) {
         const chatBlock = document.getElementById('tawkchat-container')
        if (newVal === true) {
          if (chatBlock) {
            let chatStyles = chatBlock.style.cssText
            chatBlock.style.cssText = chatStyles + '; z-index:10 !important ;'
          }
            document.getElementById("app").classList.add('app-hide-overflow')
        } else {
            document.getElementById("app").classList.remove('app-hide-overflow')
        }
    }
  }
}
</script>

<style>
  .mobile-account-drop>button{
    background-color: transparent !important;
    outline: none !important;
    border: none !important;
  }
  .account-icon .dropdown-toggle {
    background-color: transparent !important;
    border: none !important;
    padding-top: 0 !important;
  }

  .account-icon ul {
    left: inherit;
    right: 0!important;
  }
  .icon {
    padding-bottom: 2px;
    width: 35px;
    display: block;
  }
  .header-logo{
    height: 54px;
    max-width: 100%;
    object-fit: contain;
  }
  .navbar-container{
    height: 70px;
  }
  .main-menu #nav-collapse {
    width: 100%;
    z-index: 20;
    top: 0;
    left: 0;
  }
  .mobile-account-drop .dropdown-menu{
    right: 0 !important;
    left: -35px;
    top: 0;
    background-color: #0b1112;
    color:#ffffff;
    box-shadow:0 0 0 0.1rem inset rgba(238, 37, 41, 0.58);
    padding: 2px 0;
    transform: translate3d(-67px, 48px, 0px) !important;
    min-width: 10rem;
    z-index: 11;
  }

  .mobile-account-drop button:after{
    display: none !important;
  }
  .mobile-account-drop .dropdown-item,
  .mobile-account-drop .dropdown-item a{
    color:#ffffff;
    font-size: 15px;
  }
  .mobile-account-drop .dropdown-item{
    padding: 5px 18px !important;
  }
  .menu-list ul .nav-item {
    font-size: 18px;
    text-align: left;
  }
  @media (max-width: 991px) and (min-width: 320px) {
    .menu-list>ul{
      background-color: #070a11;
    }
    .main-menu .navbar-toggler[aria-expanded=false] {
      top: 20px;
      font-size: unset;
      border: none!important;
      z-index: 50;
      margin-top: 0;
      border-radius: 0;
      right: 0;
    }
    .main-menu .navbar-toggler[aria-expanded=true] {
      z-index: 21;
      position: fixed;
      top: 10px;
      left: 10px;
      width: 40px;
      background: #e5001b;
      height: 37px;
      font-size: 20px;
      border: none;
      border-radius: 0;
    }
    .main-menu .navbar-collapse {
      position: fixed;
      width: 100vw;
      z-index: 10;
      top: 0;
      height: 100%;
      padding-top: 20px;
      overflow-y: scroll;
      background-color: rgba(0,0,0,.42);
    }
    .menu-list {
      background-color: #000;
      margin-right: 0;
      margin-left: auto;
      height: 100%;
    }
    .mobile-expanded-logo {
      max-width: 140px;
    }
  }
  @media screen and (max-width: 375px) {
    .main-menu .navbar-toggler[aria-expanded=true] {
      background-color: unset;
      font-size: 28px;
      right: 15px;
      left: unset;
    }
    .mobile-expanded-logo {
      max-width: 140px;
    }
  }


</style>
<style scoped>
  .fa-spinner{
    color:#ffffff;
    font-size: 16px;
  }
  .mobile-header-menu {
    position: absolute;
    top: 0;
    left: 0;
  }
  .header-block{
    background-color: #070a11;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 10;
  }
  .header-logo-container{
    display: flex;
    padding: 0 ;
  }
  .header-logo-route{
    display: flex;
  }

  .header-balance-info{
    font-size: 14px;
  }
  .header-username,.header-balances{
    color: #ffffff;
    display: block;
    text-align: center;
  }
  .logout-link{
    line-height: 40px;
  }
  @media screen and  (min-width: 1450px) {
    .header-username,.header-balances{
      text-align: right;
    }
    .logout-link{
      line-height: unset;
    }
  }
  @media screen and (min-width: 1020px) and (max-width: 1580px) {
    .menu-item{
      font-size: 13px;
    }
  }
  @media screen and (min-width: 992px) and (max-width: 1050px) {
    .menu-item{
      font-size: 13px;
    }
    .header-logo{
      height: 40px;
    }
  }
</style>
